import './AnnotationControls.css'
import formatMessage from 'format-message'
import React from 'react'
import AnnotationControlButton from './AnnotationControlButton'
import SelectionIcon from './icons/SelectionIcon'
import PointIcon from './icons/PointIcon'
import HighlightIcon from './icons/HighlightIcon'
import StrikeoutIcon from './icons/StrikeoutIcon'
import DrawIcon from './icons/DrawIcon'
import AreaIcon from './icons/AreaIcon'
import FreetextIcon from './icons/FreetextIcon'

export default function AnnotationControls({ onChange, isAnnotatable, controlMode }) {
  const toggleAnnotationType = (type, event) => {
    event.stopPropagation()
    onChange(type)
  }

  return (
    <nav className="AnnotationControls" style={{ marginRight: '12px' }}>
      {isAnnotatable && [
        <AnnotationControlButton
          key="select"
          ariaLabel={formatMessage('Enter selection mode')}
          tooltip={formatMessage('Selection')}
          controlMode="selection"
          currentControlMode={controlMode}
          onClick={toggleAnnotationType.bind(null, 'selection')}
        >
          <SelectionIcon />
        </AnnotationControlButton>,
        <AnnotationControlButton
          key="point"
          tooltip={formatMessage('Point annotation')}
          controlMode="point"
          currentControlMode={controlMode}
          onClick={toggleAnnotationType.bind(null, 'point')}
        >
          <PointIcon />
        </AnnotationControlButton>,
        <AnnotationControlButton
          key="highlight"
          tooltip={formatMessage('Highlight annotation')}
          controlMode="highlight"
          currentControlMode={controlMode}
          onClick={toggleAnnotationType.bind(null, 'highlight')}
        >
          <HighlightIcon />
        </AnnotationControlButton>,
        <AnnotationControlButton
          key="freetext"
          tooltip={formatMessage('Freetext annotation')}
          controlMode="freetext"
          currentControlMode={controlMode}
          onClick={toggleAnnotationType.bind(null, 'freetext')}
        >
          <FreetextIcon />
        </AnnotationControlButton>,
        <AnnotationControlButton
          key="strikeout"
          tooltip={formatMessage('Strikeout annotation')}
          controlMode="strikeout"
          currentControlMode={controlMode}
          onClick={toggleAnnotationType.bind(null, 'strikeout')}
        >
          <StrikeoutIcon />
        </AnnotationControlButton>,
        <AnnotationControlButton
          key="draw"
          tooltip={formatMessage('Free draw annotation')}
          controlMode="ink"
          currentControlMode={controlMode}
          onClick={toggleAnnotationType.bind(null, 'ink')}
        >
          <DrawIcon />
        </AnnotationControlButton>,
        <AnnotationControlButton
          key="area"
          tooltip={formatMessage('Area annotation')}
          controlMode="area"
          currentControlMode={controlMode}
          onClick={toggleAnnotationType.bind(null, 'area')}
        >
          <AreaIcon />
        </AnnotationControlButton>,
      ]}
    </nav>
  )
}
